import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { styled } from '@mui/system';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ReviewsNotSelected, ReviewsNotExist } from '@features/ReviewsEmptyFeed';
import ContactDrawer from '@features/ContactDrawer';
import { contactsActions } from '@actions';
import TicketForm from '../TicketForm';
import FeedbackItem from './FeedbackItem';
import { FeedbackItemSkeleton, FeedbacksSkeleton } from './FeedbacksSkeleton';

const FeedbacksContainer = styled('div')({
    height: 'calc(var(--100vh) - 96px - var(--page-title-height))',
    backgroundColor: '#F2F2F2',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    overflowY: 'auto',
    borderRadius: 8,
    '@media (max-width: 1024px)': {
        height: 'calc(var(--100vh) - 172px)',
        margin: '0 -16px',
        borderRadius: 0,
    },
});

const Feedbacks = ({
    data,
    language,
    pageToken,
    fetchData,
    loading,
    feedType,
    onUpdateContactCallback,
    onInitConversationCallback,
    onFilterByLocation,
    onFilterBySurvey,
}) => {
    const [ticketData, setTicketData] = useState(null);

    const { contact } = useSelector(state => state.contacts);
    const dispatch = useDispatch();
    const handleCloseTicket = () => setTicketData(null);

    const handleOpenTicket = ({ id, ticket, type, locationId }) => setTicketData({ id, ticket, type, locationId });

    const onClickContactDetails = contactId => {
        if (contactId !== contact?.id) {
            dispatch(contactsActions.getContact(contactId));
        }
        dispatch(contactsActions.setContactDrawer(true));
    };

    const getEmptyComponent = () => {
        switch (feedType) {
            case 1:
                return <ReviewsNotSelected type="feedback" />;
            case 3:
                return <ReviewsNotExist />;
            default:
                return null;
        }
    };

    if (loading) {
        return (
            <FeedbacksContainer id="pl-feed-feedbacks">
                <FeedbacksSkeleton data={data} />
            </FeedbacksContainer>
        );
    }

    if (feedType) {
        return (
            <FeedbacksContainer style={{ padding: '16px' }} id="pl-feed-feedbacks">
                {getEmptyComponent()}
            </FeedbacksContainer>
        );
    }

    return (
        <FeedbacksContainer id="pl-feed-feedbacks">
            <InfiniteScroll
                dataLength={data.length}
                next={fetchData}
                hasMore={!!pageToken}
                loader={<FeedbackItemSkeleton data={data} />}
                style={{ padding: '16px', overflow: 'hidden' }}
                scrollableTarget="pl-feed-feedbacks"
            >
                {data.map((item, index) => (
                    <FeedbackItem
                        key={item?.id || `feedback-${index}`}
                        item={item}
                        index={index}
                        language={language}
                        handleOpenTicket={handleOpenTicket}
                        onClickContactDetails={onClickContactDetails}
                        onFilterByLocation={onFilterByLocation}
                        onFilterBySurvey={onFilterBySurvey}
                    />
                ))}
            </InfiniteScroll>
            {ticketData ? <TicketForm ticketData={ticketData} onClose={handleCloseTicket} /> : null}
            <ContactDrawer
                onUpdateCallback={onUpdateContactCallback}
                onInitConversationCallback={onInitConversationCallback}
            />
        </FeedbacksContainer>
    );
};

export default Feedbacks;
